import React, { Fragment } from 'react';
import { HashRouter, BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose, branch, renderComponent, mapProps } from 'recompose';
import { withTracker } from '@skooldio/analytics-provider';

import { Flex } from 'Components/Base';

import { isLoading, isLogin, myRoles } from '../Redux/user-profile/selectors';
import Loading from '../Components/Loading';

const CannotAccess = () => <div>You do not have permission to access this page</div>;

const redirectLoginHoc = branch(
  (props) => !props.isLogin,
  renderComponent(
    mapProps((props) => ({
      to: {
        pathname: '/login',
        state: { from: props.redirectTo ? props.redirectTo : props.location },
      },
    }))(Redirect)
  )
);

const notAccessHoc = (roles = []) =>
  branch(
    ({ isLogin, myRoles }) =>
      isLogin && roles && roles.length > 0 && !roles.some((role) => myRoles.indexOf(role) >= 0),
    renderComponent(CannotAccess)
  );

const FullscreenLoading = () => (
  <Flex justifyContent={'center'} alignItems={'center'} width={1} height={'100vh'}>
    <Loading />
  </Flex>
);

const AuthenHOC = (enabledRoles = []) =>
  compose(
    connect((state) => {
      return {
        isLoading: isLoading(state),
        isLogin: isLogin(state),
        myRoles: myRoles(state),
      };
    }),
    branch((props) => props.isLoading, renderComponent(FullscreenLoading)),
    redirectLoginHoc,
    notAccessHoc(enabledRoles)
  );

export const PrivateRoute = ({
  component: Component,
  layout: Layout = Fragment,
  roles,
  redirectTo,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      const AuthComp = compose(AuthenHOC(roles), withTracker())(Component);
      return (
        <Layout>
          <AuthComp redirectTo={redirectTo} {...props} />
        </Layout>
      );
    }}
  />
);

export const PublicRoute = ({ component: Component, layout: Layout = Fragment, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const CompWithTracker = withTracker()(Component);
      return (
        <Layout>
          <CompWithTracker {...props} />
        </Layout>
      );
    }}
  />
);

const GenRoute = ({ menus }) =>
  menus.map((menu) =>
    menu.private ? (
      <PrivateRoute
        key={'route' + menu.path}
        path={menu.path}
        exact={menu.exact}
        component={menu.route}
        roles={menu.roles}
        redirectTo={menu.redirectTo}
        layout={menu.layout}
      />
    ) : (
      <PublicRoute
        key={'route' + menu.path}
        path={menu.path}
        exact={menu.exact}
        layout={menu.layout}
        component={menu.route}
      />
    )
  );

const GenSwitchRoute = ({ menus, ...restProps }) => (
  <Switch>
    {menus.map((menu) => {
      return menu.private ? (
        <PrivateRoute
          key={'route' + menu.path}
          path={menu.path}
          exact={menu.exact}
          component={menu.route}
          roles={menu.roles}
          componentProps={restProps}
          redirectTo={menu.redirectTo}
          layout={menu.layout}
          // menus={menus}
        />
      ) : (
        <PublicRoute
          key={'route' + menu.path}
          path={menu.path}
          exact={menu.exact}
          component={menu.route}
          componentProps={restProps}
          layout={menu.layout}
          // menus={menus}
        />
      );
    })}
  </Switch>
);

export const MainRoute = process.env.PLATFORM === 'electron' ? HashRouter : BrowserRouter;

export { GenRoute, GenSwitchRoute };

export default { PrivateRoute, PublicRoute };
